<template>
    <el-dialog  title="新增角色" :visible.sync="showBlock" :close-on-click-modal="false"  :destroy-on-close="true" width='700px' :before-close="closedBtn">
            <el-form :model="formDate"  status-icon :rules="rules" ref="formDate" label-width="70px" class="demo-ruleForm">
                <el-form-item  label="角色名称" prop="name">
                    <el-input v-model="formDate.name" maxlength="9"  :size="this.$store.state.popSize" style="width:100%"    placeholder="请输入角色名称" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item  label="显示排序" prop="Value">
                   <div class="common-space-between">
                      <el-input-number v-model="formDate.orderNo" :controls="false" :size="this.$store.state.popSize" controls-position="right" @change="handleChange" :min="1" :max="1000"></el-input-number>
                      <SelectBlock left="0" right="0" keyVal="enabled" :size="this.$store.state.popSize" width="290" ref="enabled" @getVal="getVal"/>
                    </div>
                </el-form-item>
                <el-form-item  label="角色描述">
                    <el-input type="textarea" :rows="2" :size="this.$store.state.popSize"  placeholder="请输入内容"  v-model="formDate.roleDesc">  </el-input>
                </el-form-item>
                <Menu :options="options" :val="[]" keyVal="menuButtonIds" ref="menu" @getVal="getMenu" />
                <div class="warp-btn">
                    <el-form-item>
                        <div  class="dialog-footer">
                            <el-button @click="closedBtn">取消</el-button>
                            <el-button type="primary"  v-if="showBtn">
                              <i class="el-icon-loading"></i>提交
                            </el-button>
                            <el-button type="primary" v-else @click="submitForm('formDate')">提交</el-button>
                        </div>
                    </el-form-item>
                </div>
            </el-form>
    </el-dialog>
</template>
<script>

  import {url,userApi} from '@/utils/config'
  import {postFun} from '@/utils/httpFun'
  import Menu from './menu-block.vue'
  import {isEmpty} from '@/utils/util'
  export default{
     components:{
        Menu
     },
     data(){
       return{
        rules:{
            name:[{validator:isEmpty, trigger:'blur'}],
        },
        showBlock:false,
        formDate: {
            name: '',        //角色名称
            orderNo:1,       //角色排序
            enabled:"0",     //角色状态   0禁用  1启用
            roleDesc:"",     //角色描述 
        },
        showBtn:false,
       }
     },
     props:{
        options:{
           type:Array,
        }
     },
     created(){
        this.$store.commit({
            type: "setEmptyText",
            emptyText:"角色名称不空为空",
        })
     },
     methods:{
        
        //角色状态
        getVal(ev){
            this.formDate[ev.key] = ev.indexNo
        },
        //排序
        handleChange(ev){
            this.formDate.orderNo = ev
        },

        //开启弹窗
        showMessage(ev){
            this.showBlock = true
            this.formDate.orderNo = ev+1
            this.$nextTick(res=>{
                this.$refs.enabled.setVal("禁用")
                this.$refs.menu.initialize(this.options[0])
            })
        },

        //提交
        submitForm(formDate) {
            this.$refs[formDate].validate((valid) => {
                if (valid) {
                    this.submitFun()  
                    }else{
                      return false;
                }
            });
        },
        
        //选中的菜单值
        getMenu(ev){
           console.log("选中的菜单",ev)
           this.menuButtonIds = ev.val
        },
        //提交的数据
        async submitFun(){
              let parms =  {    
                name:this.formDate.name,         //角色名称 
                orderNo:this.formDate.orderNo,   //排序
                roleDesc:this.formDate.roleDesc, //角色描述
                enabled:this.formDate.enabled,   //0禁用 1启用
                roleType:0,                      //角色类型  默认0
                menuButtonIds:this.menuButtonIds,//按钮的ID
                // id:1,                         //角色ID    
                // companyId:1,                  //公司名称     
            }
            this.showBtn = true
            parms.operator = this.$store.state.operator
            await postFun(userApi.ROULEADD,parms,res=>{
                if(res.code==1){
                    this.showBlock = false
                    this.showBtn = false
                    this.closedBtn()
                    this.$parent.resetBtn()
                }   
            })
        },

        //关闭弹窗
        closedBtn(){
            this.showBlock = false
            this.formDate = {
                name:"",
                orderNo:1,
                enabled:"0",
                roleDesc:""
            }
        }
     }
  }
</script>
<style scoped lang="scss">
   .dialog-footer{
       display: flex;
       justify-content: flex-end;
   }
   .el-input-number{
       width:290px!important;
    }
   .warp-btn{
    margin-top: 20px;
    .el-form-item {
        margin-bottom:0px!important;
     }
   }
   
</style>